"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;

var _react = require("react");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/styles");

var _icons = require("@material-ui/icons");

var _usePostRequest3 = _interopRequireDefault(require("../hooks/usePostRequest"));

var _usePutRequest3 = _interopRequireDefault(require("../hooks/usePutRequest"));

var _Notification = _interopRequireDefault(require("../components/Notification"));

var _urls = require("../utils/urls");

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    footer: {
      position: "fixed",
      "@media (max-width: 992px)": {
        position: "initial"
      },
      left: 0,
      bottom: 0,
      width: "100%",
      color: "rgba(0, 0, 0, 0.87)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    paddingDivLeft: {
      padding: 10,
      paddingLeft: 60,
      display: "flex",
      justifyContent: "flex-start",
      "@media (max-width: 480px)": {
        justifyContent: "space-between"
      }
    },
    paddingDivRight: {
      padding: 10,
      display: "flex",
      justifyContent: "flex-end",
      "@media (max-width: 480px)": {
        justifyContent: "space-between"
      }
    },
    marginDiv: {
      marginLeft: 10
    },
    wrapper: {
      position: "relative"
    },
    transparent: {
      backgroundColor: "transparent !important"
    },
    mTop5: {
      marginTop: 5
    }
  };
});
var INDEX_PATH = "/form-builder/lists";

function Footer(_ref) {
  var data = _ref.data,
      formName = _ref.formName,
      gridSize = _ref.gridSize,
      multiple = _ref.multiple,
      typeForm = _ref.typeForm,
      isAdvance = _ref.isAdvance,
      advanceCount = _ref.advanceCount,
      onOpenModal = _ref.onOpenModal,
      isUpdate = _ref.isUpdate,
      token = _ref.token,
      navigate = _ref.navigate;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      openAlert = _useState2[0],
      setOpenAlert = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      idResponse = _useState4[0],
      setIdResponse = _useState4[1];

  (0, _react.useEffect)(function () {
    var formattedFields = _utils.default.saveDataForConsumption(data);

    localStorage.setItem("formData", JSON.stringify(formattedFields));
  }, [data]); // save data

  var _usePostRequest = (0, _usePostRequest3.default)("".concat(_urls.API_FULL, "/form-builders"), token),
      _usePostRequest2 = _slicedToArray(_usePostRequest, 2),
      loadingSave = _usePostRequest2[0].loading,
      saveData = _usePostRequest2[1]; // update data


  var _usePutRequest = (0, _usePutRequest3.default)(isUpdate || idResponse ? "".concat(_urls.API_FULL, "/form-builders/").concat(idResponse ? idResponse : isUpdate) : null, token),
      _usePutRequest2 = _slicedToArray(_usePutRequest, 2),
      loadingUpdate = _usePutRequest2[0].loading,
      updateData = _usePutRequest2[1];

  var saveDataForPreview = function saveDataForPreview(device) {
    window.open("/form-builder/preview/".concat(device), "_blank");
  };

  var handleSaveOrUpdate = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            response = null;

            if (!(isUpdate || idResponse)) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return updateData({
              name: formName,
              gridSize: gridSize,
              multiple: multiple,
              typeForm: typeForm,
              isAdvance: isAdvance,
              advanceCount: advanceCount,
              data: data
            });

          case 4:
            _context.next = 10;
            break;

          case 6:
            _context.next = 8;
            return saveData({
              name: formName,
              gridSize: gridSize,
              multiple: multiple,
              typeForm: typeForm,
              isAdvance: isAdvance,
              advanceCount: advanceCount,
              data: data
            });

          case 8:
            response = _context.sent;
            setIdResponse(response._id);

          case 10:
            setOpenAlert(true);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [advanceCount, data, formName, gridSize, idResponse, isAdvance, isUpdate, multiple, saveData, typeForm, updateData]);

  var handleCloseAlert = function handleCloseAlert(e, reason) {
    if (reason === "clickaway") {
      return;
    }

    setOpenAlert(false);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    direction: "row",
    alignItems: "flex-end"
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    className: classes.paddingDivLeft
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Preview del formulario"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mTop5
  }, /*#__PURE__*/React.createElement(_core.IconButton, {
    disableFocusRipple: true,
    disableRipple: true,
    color: "primary",
    "aria-label": "desktop",
    className: classes.transparent,
    onClick: function onClick() {
      return saveDataForPreview("desktop");
    }
  }, /*#__PURE__*/React.createElement(_icons.DesktopMacRounded, null)), /*#__PURE__*/React.createElement(_core.IconButton, {
    disableFocusRipple: true,
    disableRipple: true,
    color: "primary",
    "aria-label": "tablet",
    className: classes.transparent,
    onClick: function onClick() {
      return saveDataForPreview("tablet");
    }
  }, /*#__PURE__*/React.createElement(_icons.Tablet, null)), /*#__PURE__*/React.createElement(_core.IconButton, {
    disableFocusRipple: true,
    disableRipple: true,
    color: "primary",
    "aria-label": "phone",
    className: classes.transparent,
    onClick: function onClick() {
      return saveDataForPreview("mobile");
    }
  }, /*#__PURE__*/React.createElement(_icons.PhoneAndroid, null)))), /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Configuraci\xF3n inicial"
  }, /*#__PURE__*/React.createElement(_core.IconButton, {
    disableFocusRipple: true,
    disableRipple: true,
    className: classes.transparent,
    color: "primary",
    "aria-label": "settings",
    onClick: function onClick() {
      return onOpenModal();
    }
  }, /*#__PURE__*/React.createElement(_icons.Settings, {
    fontSize: "large"
  })))), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12,
    sm: 6,
    className: classes.paddingDivRight
  }, /*#__PURE__*/React.createElement(_core.Button, {
    variant: "outlined",
    color: "default",
    className: classes.button,
    onClick: function onClick() {
      return navigate(INDEX_PATH);
    },
    size: "medium"
  }, "Volver"), /*#__PURE__*/React.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    className: classes.marginDiv,
    startIcon: /*#__PURE__*/React.createElement(_icons.Save, null),
    onClick: handleSaveOrUpdate,
    disabled: loadingSave || loadingUpdate,
    size: "medium"
  }, loadingSave || loadingUpdate ? /*#__PURE__*/React.createElement(_core.CircularProgress, {
    size: 22
  }) : !isUpdate && !idResponse ? "Guardar" : "Actualizar"))), /*#__PURE__*/React.createElement(_Notification.default, {
    openAlert: openAlert,
    onCloseAlert: handleCloseAlert,
    message: "Formulario guardado exitosamente"
  }));
}